export {
  CARD_WATCH_REASON,
  CLOSED_REASON,
  FRAUDULENT_CLOSED_REASONS,
  RESTRICTIVE_TIERED_WATCH_REASONS,
  RETURNED_MAIL_REASON,
  STATUS_OPTIONS,
  TIERED_WATCH_REASON,
} from 'utilities/accountStatusConstants';

export const FORM_FIELD = Object.freeze({
  REASON_CODE: 'reasonCode',
  STATUS_CODE: 'statusCode',
  APPLY_TO_ALL_ACCOUNTS: 'applyToAllAccounts',
  CLOSURE_AUTHORIZED: 'closureAuthorized',
  CLOSURE_FRAUD_TYPE: 'closureFraudType',
  CLOSURE_FRAUD_TYPE_STATUS_TIMEFRAME: 'closureFraudTypeStatusTimeFrame',
  FRAUD_TIMEFRAME: 'fraudTimeframe',
  OVERWRITE_STATUS: 'overwriteStatus',
});

export const DEFAULT_STATUS_FORM_VALUES = {
  [FORM_FIELD.APPLY_TO_ALL_ACCOUNTS]: false,
  [FORM_FIELD.CLOSURE_AUTHORIZED]: false,
  [FORM_FIELD.CLOSURE_FRAUD_TYPE]: undefined,
  [FORM_FIELD.CLOSURE_FRAUD_TYPE_STATUS_TIMEFRAME]: [],
  [FORM_FIELD.STATUS_CODE]: undefined,
  [FORM_FIELD.REASON_CODE]: undefined,
  [FORM_FIELD.FRAUD_TIMEFRAME]: undefined,
  [FORM_FIELD.OVERWRITE_STATUS]: false,
};

/**
 * FIXED PAY
 */
export const FIXED_PAY_REASON = Object.freeze({
  CREDIT_COUNSELING: 'CC',
  PAY_OFF: 'PO',
  SYSTEM_SET: 'SY',
});
